module.exports = __webpack_public_path__ + "img/bg_block.60e8e567.png";